<div class="info">
  <div class="text-info" [innerHTML]="libraryInfo"></div>
  <div class="library-subscription-link" (click)="navigate('library-subscription')">Управление подпиской</div>
</div>

<div class="dropped-filter-list">
  <input #search  id="search" [hidden]="false"
         class="base-input search-input"
         [(ngModel)]="searchString"
         [placeholder]="'Искать в библиотеке'"
         (ngModelChange)="find()"
         [formControl]="findStrControl">
  <mat-select  class="mat-select" #selectCategory placeholder="Выберите категорию"
              (selectionChange)="changeCategory()">
    <mat-option>Все</mat-option>
    <mat-option *ngFor="let i of categories" [value]="i.id">
       {{libraryCategoryNames[i.categoryName]}}
    </mat-option>
  </mat-select>

</div>

<div class="products-list-cont">

  <div class="products-list" *ngIf="!loading ">
    <div
      *ngFor="let item of items | paginate:  { itemsPerPage: productsCountOnPage, currentPage: page, totalItems: total  }"
      class="product-item">

      <library-item [libraryItem]="item"></library-item>

    </div>


  </div>
  <div *ngIf="items.length == 0 && !loading" class="not-found">По Вашему запросу ничего не найдено</div>

  <pagination-controls *ngIf="items && showPagination && !loading &&  total > productsCountOnPage" class="pagination"
                       previousLabel=""
                       nextLabel=""
                       (pageChange)="change($event);setBaseScrollPosition()"
  >

  </pagination-controls>

  <div class="spinner" *ngIf="loading">
    <mat-spinner></mat-spinner>

  </div>
</div>
